import { Directive, ElementRef, Renderer2 } from '@angular/core';

@Directive({
  selector: 'input[appAutocompleteOff]',
})
export class AutoCompleteOffDirective {
  constructor(
    private el: ElementRef,
    private renderer: Renderer2,
  ) {
    this.renderer.setAttribute(this.el.nativeElement, 'autocomplete', 'off');
  }
}
